import { Button } from '@/ui/components/common/Button'

interface PaginatorProps {
  page: number
  total: number
  onChange: (page: number) => void
}

/**
 * Renders prev/next pagination controls with the current page indicator;
 * returns nothing when there's a single page.
 */
export function Paginator({ page, total, onChange }: PaginatorProps) {
  if (total <= 1) return null
  return (
    <div className="flex items-center justify-center gap-3 mt-6">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
      >
        ←
      </Button>
      <span className="text-sm text-muted-foreground">
        {page} / {total}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onChange(Math.min(total, page + 1))}
        disabled={page >= total}
      >
        →
      </Button>
    </div>
  )
}
